import styled from "styled-components";

export const TendbeQRCodeBorder = styled.div<{
    color: string;
    displaySize: number;
}>`
    border-radius: 20px;
    margin: auto;
    width: 100%;
    display: flex;
    justify-content: center;
    > canvas {
        border-radius: 20px;
        border: 3px solid ${(props) => props.color};
        /* Keep high-res source but let the displayed canvas shrink on narrow layouts. */
        width: 100% !important;
        max-width: ${(props) => props.displaySize}px !important;
        height: auto !important;
    }
`;
